'use strict';

import store from "../../store";

export default async function auth({ next, to }) {
    await store.dispatch("Auth/fetchUser", true);

    if(!store.getters["Auth/user"])
        store.dispatch("Auth/unAuthenticated", {intendedUrl: to.fullPath});
    else
        return next();
}
